module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("kEOlD"))).then(() => parcelRequire('hEqeo'));